import {Collapse, Grid} from '@mui/material';
import {size} from 'lodash';
import {useState, useEffect} from 'react';
import {CartDTO} from '../../../api/models';
import {ViolationItem} from './ViolationItem';

export const CartIssues = ({cartDTO}: {cartDTO?: CartDTO}) => {
    const [showViolations, setShowViolations] = useState(false);

    useEffect(() => {
        const doesCartHaveViolations = size(cartDTO?.violations) !== 0;
        setShowViolations(doesCartHaveViolations);
    }, [cartDTO?.violations]);

    if (cartDTO) {
        if (cartDTO.violations.length !== 0) {
            return (
                <Collapse in={showViolations}>
                    <Grid style={{marginTop: 12}} container>
                        {cartDTO.violations.map((violation, idx) => {
                            return <ViolationItem cartId={cartDTO.cartId} key={idx} violation={violation} />;
                        })}
                    </Grid>
                </Collapse>
            );
        }
    }
    return <></>;
};
